import { useIntl } from 'react-intl';
import { useMutation } from '@tanstack/react-query';

import download from 'src/utils/download';
import { API } from 'src/reactQuery/Api';
import { getRequest, serialize } from 'src/utils/request';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';
import messages from 'src/pages/ProjectDetailsPage/components/JobList/messages';

const SUCCESS_MESSAGE_DURATION = 1000;

const downloadProjectJobs = async (projectId: string, projectUuid: string) => {
  const queryFilters = serialize({ project_uuid: projectUuid }, 'filters');
  const params = `?${queryFilters.toString()}`;
  const { data } = await getRequest(
    API.GET.getProjectJobsBulkExport(projectUuid, params),
    { responseType: 'blob' },
  );

  download(data, `Jobs_PID_${projectId}.csv`, 'text/csv');
  return data;
};

export const useDownloadProjectJobs = (
  projectId: string,
  projectUuid: string,
) => {
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  const { mutate: downloadJobs, isPending: isDownloading } = useMutation({
    mutationFn: () => downloadProjectJobs(projectId, projectUuid),
    onSuccess: () => {
      handleSuccess(
        formatMessage(messages.jobsDownloaded),
        SUCCESS_MESSAGE_DURATION,
      );
    },
    onError: handleError,
  });

  return { downloadJobs, isDownloading };
};
